import { createReducer } from '@reduxjs/toolkit'
import { IStateCurrentTrailer } from './TReducer'
import { Actions_CurrentTrailer } from './Actions'

const initialState: IStateCurrentTrailer = {
  isLoading: false,
  data: null,
  responseInfo: null,
  selectedTrailerInfo: null,
}

const ReducerCurrentTrailer = createReducer(initialState, (builder) => {
  builder
    .addCase(Actions_CurrentTrailer.store.showLoader, (state) => {
      state.isLoading = true
    })
    .addCase(Actions_CurrentTrailer.store.hideLoader, (state) => {
      state.isLoading = false
    })
    .addCase(Actions_CurrentTrailer.store.saveCurrentTrailer, (state, action) => {
      const payload = action.payload
      return { ...state, ...payload }
    })
    .addCase(Actions_CurrentTrailer.store.changeSelectedTrailerInfo, (state, action) => {
      state.selectedTrailerInfo = action.payload
    })
    .addCase(Actions_CurrentTrailer.store.clearSelectedTrailerInfo, (state) => {
      state.selectedTrailerInfo = null
    })
})

export default ReducerCurrentTrailer
